import { AnyAction, Dispatch } from 'redux';
import { TcsmEpiApiActionTypes } from '../models/epi-model';
import { ApiAction } from '../models/api-model';
import { apiAction } from './base-api';
import { ApiEndpoint } from '../constants/api-endpoints';
import { TcsmEpiApiState } from '../../root/tcsm-model';

export const standAlone = (window as any)?.bootstrap?.standAlone;
const BaseUrl = `${standAlone ? ApiEndpoint.contentApi : ''}/api/v1/epicontent`;
const podBase = `${standAlone ? ApiEndpoint.contentApi : ''}/api/v1/content?path=my-cpg-accounts/pods/`;

export const tcsmEpiApiReducerWithDefault = (defaultState: TcsmEpiApiState) => (state = defaultState, action: AnyAction) => {
	switch (action.type) {
		case TcsmEpiApiActionTypes.SET_EPI_PROPS:
			return {
				...state,
				contentState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_LABEL_EPI_PROPS:
			return {
				...state,
				labelSettingState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_PERSONALINFO_PROPS:
			return {
				...state,
				personalInfoSettingState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_RELATIONSHIPS_PROPS:
			return {
				...state,
				relationshipsSettingState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_COMPENSATION_PROPS:
			return {
				...state,
				compensationSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_EMPLOYMENT_PROPS:
			return {
				...state,
				employmentSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_INSTITUTION_PROPS:
			return {
				...state,
				institutionSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_SEARCH_PROPS:
			return {
				...state,
				searchSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_PERSON_SEARCH_PROPS:
			return {
				...state,
				personSearchSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_GROUPS_BILLING_PROPS:
			return {
				...state,
				groupsBillingSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_SITE_SETTINGS_PROPS:
			return {
				...state,
				siteSettingsState: {
					siteSettings: action.payload,
					siteSettingsLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_ANNUAL_ENROLLMENT_PROPS:
			return {
				...state,
				annualEnrollmentSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_PENSION_ENROLLMENT_PROPS:
			return {
				...state,
				pensionEnrollmentSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_NEW_HIRE_PROPS:
			return {
				...state,
				newHireSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_MID_YEAR_PROPS:
			return {
				...state,
				midYearSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_TERMINATION_PROPS:
			return {
				...state,
				terminationSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case TcsmEpiApiActionTypes.SET_GPS_PROPS:
			return {
				...state,
				gpsSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_MAP_PORTAL_PROPS:
			return {
				...state,
				mapPortalSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};


		case TcsmEpiApiActionTypes.SET_EPI_PAGE_DATA:
			return {
				...state,
				pageData: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case TcsmEpiApiActionTypes.UNLOAD_EPI_PAGE_DATA:
			return {
				...state,
				pageData: {
					epiContent: null,
					contentLoaded: false,
				},
			};

		case TcsmEpiApiActionTypes.SET_PODS_SETTINGS:
			return {
				...state,
				podsSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case TcsmEpiApiActionTypes.SET_COMP_REPORT_SETTINGS:
			return {
				...state,
				clergyCompReportSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case TcsmEpiApiActionTypes.SET_CLERGY_BIO_SETTINGS:
			return {
				...state,
				clergyBioSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_PARTICIPANT_ENROLLMENT_SETTINGS:
			return {
				...state,
				participantEnrollmentSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_BENEFICIARY_SETTINGS:
			return {
				...state,
				beneficiarySettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};
		case TcsmEpiApiActionTypes.SET_MYCPGMIDYEAR_SETTINGS:
			return {
				...state,
				myCpgMidyearSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};


		case TcsmEpiApiActionTypes.SET_CIC_SETTINGS:
			return {
				...state,
				cicSettingsState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		default:
			return state;
	}
};


const setEpiProps = (dispatch: Dispatch<any>) => (data: any) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_EPI_PROPS,
		payload: data,
	});
};

export const setLabelSetting = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_LABEL_EPI_PROPS,
		payload: data,
	});
};

export const setPersonalInfoSetting = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_PERSONALINFO_PROPS,
		payload: data,
	});
};

export const setRelationshipsSetting = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_RELATIONSHIPS_PROPS,
		payload: data,
	});
};

export const setCompensationSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_COMPENSATION_PROPS,
		payload: data,
	});
};

export const setEmploymentSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_EMPLOYMENT_PROPS,
		payload: data,
	});
};

export const setInstitutionSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_INSTITUTION_PROPS,
		payload: data,
	});
};

export const setSearchSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_SEARCH_PROPS,
		payload: data,
	});
};

export const setPersonSearchSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_PERSON_SEARCH_PROPS,
		payload: data,
	});
};

export const setGroupsBillingSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_GROUPS_BILLING_PROPS,
		payload: data,
	});
};

export const setSiteSettingsProps = (dispatch: Dispatch<any>) => (data: any) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_SITE_SETTINGS_PROPS,
		payload: data,
	});
};

export const setAnnualEnrollmentSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_ANNUAL_ENROLLMENT_PROPS,
		payload: data,
	});
};

export const setPensionEnrollmentSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_PENSION_ENROLLMENT_PROPS,
		payload: data,
	});
};

export const setNewHireSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_NEW_HIRE_PROPS,
		payload: data,
	});
};

export const setMidYearSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_MID_YEAR_PROPS,
		payload: data,
	});
};

export const setTerminationSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_TERMINATION_PROPS,
		payload: data,
	});
};

export const setMapPortalSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_MAP_PORTAL_PROPS,
		payload: data,
	});
};

export const setGpsSetting = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_GPS_PROPS,
		payload: data,
	});
};

export const setEpiContent = (data: any) => {
	return {
		type: TcsmEpiApiActionTypes.SET_EPI_PAGE_DATA,
		payload: data,
	};
};

export const unloadEpiContent = () => {
	return {
		type: TcsmEpiApiActionTypes.UNLOAD_EPI_PAGE_DATA,
	};
};

export const setPodsSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_PODS_SETTINGS,
		payload: data,
	});
};

export const setClergyCompensationReportSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_COMP_REPORT_SETTINGS,
		payload: data,
	});
};


export const setClergyBioSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_CLERGY_BIO_SETTINGS,
		payload: data,
	});
};

export const setParticipantEnrollmentSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_PARTICIPANT_ENROLLMENT_SETTINGS,
		payload: data,
	});
};

export const setBeneficiarySeetings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_BENEFICIARY_SETTINGS,
		payload: data,
	});
};

export const setMyCPGMidyearSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_MYCPGMIDYEAR_SETTINGS,
		payload: data,
	});
};


export const getTcsmEpiProps = (dispatch: Dispatch<any>, contentId: string, payloadData: any, language: string = 'en', siteSettings: boolean = false, setter = setEpiProps): ApiAction => {
	return apiAction({
		url: `${BaseUrl}/getbyid/?contentId=${contentId}&language=${language}`,
		onSuccess: siteSettings ? setSiteSettingsProps(dispatch) : setter(dispatch),
		payloadData,
	});
};

export const getTcsmEpiContent = (url: string, language: string = 'en', payloadData: any, onSuccess: (data) => void, onFailure: () => void): ApiAction => {
	return apiAction({
		url: `${BaseUrl}/getpagefromurl/?url=${url}&language=${language}`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getPodsContent = (url: string, onSuccess: (data) => void): ApiAction => {
	return apiAction({
		url: `${podBase}${url}`,
		onSuccess,
	});
};


export const setCicSettings = (dispatch: Dispatch<any>) => <TProps>(data: TProps) => {
	dispatch({
		type: TcsmEpiApiActionTypes.SET_CIC_SETTINGS,
		payload: data,
	});
};
